export default __webpack_public_path__ + "static/1-kotlin-results-08ee585f80acbee20a9b7a8b1ecbeee0.png";